import { AxiosResponse } from 'axios'
import { api } from 'API'
import { ITrainingComponent, TrainingComponentType } from 'interfaces/training-component'

// The shared `api` axios instance auto-stamps `?orgId=` from the active team;
// the server validates membership and derives the org scope from it. No orgId
// is ever sent in the body/query by these calls.

export interface ListTrainingComponentsParams {
  q?: string
  type?: TrainingComponentType
  sort?: 'mostUsed' | 'recent'
  skip?: number
  limit?: number
}

export interface ListTrainingComponentsResult {
  items: ITrainingComponent[]
  total: number
}

export async function listTrainingComponents(
  params: ListTrainingComponentsParams = {}
): Promise<ListTrainingComponentsResult> {
  const response: AxiosResponse = await api.get('/training-components', { params })
  return response.data
}

export async function getTrainingComponentById(id: number): Promise<ITrainingComponent> {
  const response: AxiosResponse = await api.get(`/training-components/${id}`)
  return response.data
}

export async function createTrainingComponent(body: {
  type: TrainingComponentType
  rootId: number
  name: string
  tags?: string[]
}): Promise<ITrainingComponent> {
  const response: AxiosResponse = await api.post('/training-components', body)
  return response.data
}

export async function instantiateTrainingComponent(
  id: number,
  body: { parentType: 'trainingplan' | TrainingComponentType; parentId: number; position: number }
): Promise<{ rootId: number; rootType: string }> {
  const response: AxiosResponse = await api.post(`/training-components/${id}/instantiate`, body)
  return response.data
}

export async function updateTrainingComponent(
  id: number,
  body: { name?: string; tags?: string[] }
): Promise<void> {
  await api.patch(`/training-components/${id}`, body)
}

export async function deleteTrainingComponent(id: number): Promise<void> {
  await api.delete(`/training-components/${id}`)
}
